import React from 'react';

import Subtitle from '../../components/Subtitle';
import DownloadCTA from '../../components/DownloadCTA';

import logo from './assets/logo.png';
import hero5Desktop from './assets/hero5-desktop.png';

const ShoppingIntroSection = () => (
  <section className="bg-[#efeae7] py-12">
    <div className="max-w-[1300px] w-full px-5 mx-auto grid md:grid-cols-2 gap-10 md:gap-20 items-center">
      {/* Left content */}
      <div className="space-y-6 flex flex-col items-center md:items-start">
        <img src={logo} alt="Multi Logo" className="h-7" width={126} height={28} />
        <Subtitle className="font-light md:text-3xl text-[#003424] text-center md:text-left">
          Comece a aproveitar
          <br />
          o melhor do seu shopping favorito
          <br />
          com o Multi
        </Subtitle>
        <DownloadCTA className="mt-8" />
      </div>

      {/* Right image */}
      <div className="flex justify-center md:justify-end items-center">
        <img src={hero5Desktop} alt="Tela do aplicativo Multi" className="max-w-full h-auto mb-[-120px]" />
      </div>
    </div>
  </section>
);

export default ShoppingIntroSection;
